import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-sand">
                <div className="flex flex-col items-center gap-3" data-testid="loading-indicator">
                    <div className="h-2 w-32 bg-sand-300 rounded-full overflow-hidden">
                        <div className="h-full w-1/3 bg-terracotta animate-pulse" />
                    </div>
                    <p className="pt-eyebrow">wird geladen</p>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
